// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3XoUDPL6otGo","expired":"_1eOPGfnxs_KO","content":"_2nuhY0XewTxY","logo":"_2Bg6nPXuVhlo"};